var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoArtifacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.001,
    height: 66.068,
    viewBox: "0 0 77.001 66.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(-7.5 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M67.45,73.568H13.617A6.127,6.127,0,0,1,7.5,67.432v-53.8A6.127,6.127,0,0,1,13.617,7.5h9.089a6.108,6.108,0,0,1,4.326,1.8l6.488,6.509a3.054,3.054,0,0,0,2.163.9H67.45a6.127,6.127,0,0,1,6.117,6.136V67.432a6.127,6.127,0,0,1-6.117,6.136Z",
    transform: "translate(0)",
    fill: "#e0eefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M73.568,198.28v29.25a6.127,6.127,0,0,1-6.117,6.136H13.617A6.127,6.127,0,0,1,7.5,227.53V198.28a6.127,6.127,0,0,1,6.117-6.136H67.45A6.127,6.127,0,0,1,73.568,198.28Z",
    transform: "translate(0 -160.099)",
    fill: "#8ec4f4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 13.764,
    cy: 13.807,
    rx: 13.764,
    ry: 13.807,
    transform: "translate(26.77 39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M234.4,305.673l7.548,5.07a.615.615,0,0,1,0,1.02l-7.548,5.07a.612.612,0,0,1-.952-.51v-10.14a.612.612,0,0,1,.952-.51Z",
    transform: "translate(-195.911 -258.446)",
    fill: "#8ec4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M133.488,126.144h29.644a3.988,3.988,0,0,1,3.988,3.988v4.786H129.5v-4.786A3.988,3.988,0,0,1,133.488,126.144Z",
    transform: "translate(-105.782 -102.872)",
    fill: "#8ec4f4",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M118.488,126.144h29.644a3.988,3.988,0,0,1,3.988,3.988v4.786H114.5v-4.786A3.988,3.988,0,0,1,118.488,126.144Z",
    transform: "translate(-92.776 -102.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M167.641,153.638H138a1,1,0,0,1,0-1.994h29.644a1,1,0,1,1,0,1.994Z",
    transform: "translate(-112.285 -124.982)",
    fill: "#8ec4f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(63.712 53.127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 21,
    height: 20,
    transform: "translate(-0.212 0.441)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(0.865 0.545)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(1.923 1.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M8.651-14.721v6.562a.865.865,0,0,0,.865.865.865.865,0,0,0,.865-.865v-6.562l1.983,1.983a.865.865,0,0,0,1.223,0,.865.865,0,0,0,0-1.223l-3.46-3.46a.865.865,0,0,0-1.223,0l-3.46,3.46a.865.865,0,0,0,0,1.223.865.865,0,0,0,1.223,0ZM9.516-2.969a9.516,9.516,0,0,0,9.516-9.516A9.516,9.516,0,0,0,9.516-22,9.516,9.516,0,0,0,0-12.484,9.516,9.516,0,0,0,9.516-2.969Zm0-1.73A7.785,7.785,0,0,1,1.73-12.484,7.785,7.785,0,0,1,9.516-20.27,7.785,7.785,0,0,1,17.3-12.484,7.785,7.785,0,0,1,9.516-4.7Z",
    transform: "translate(0 22)",
    fill: "#8ec4f4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoArtifacts);
export default __webpack_public_path__ + "static/media/no-artifacts.6662f94884c31fae2f8545d5413fba5d.svg";
export { ForwardRef as ReactComponent };